<div class="card card-widget">
    <h6 class="card-header">
        {{title}} 
    </h6>  
    <div class="card-body">
        <ng-template [ngIf]="isLoading">
            <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando
        </ng-template>

        <ng-template [ngIf]="!isLoading && chart">
            <div class="cadastros">
                <div class="cadastro" *ngFor="let cadastro of chart.cadastros">
                    <div class="cadastro-side">
                        <sgt-cliente-cadastro-situacao-card-chart
                            [cadastro]="cadastro.cadastro"
                            [nome]="cadastro.nome"
                            [quantidadeClientes]="cadastro.quantidadeClientes"
                            [percParticipacao]="cadastro.percParticipacao">
                        </sgt-cliente-cadastro-situacao-card-chart>
                    </div>
    
                    <div class="situacoes">
                        <div class="situacao" *ngFor="let situacao of cadastro.situacoes">
                            <sgt-cliente-cadastro-situacao-card-chart
                                [cadastro]="cadastro.cadastro"
                                [situacao]="situacao.situacao"
                                [nome]="situacao.nome"
                                [quantidadeClientes]="situacao.quantidadeClientes"
                                [percParticipacao]="situacao.percParticipacao">
                            </sgt-cliente-cadastro-situacao-card-chart>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
